<ng-container [formGroup]="form">
	<div class="show-locale">
		<mat-form-field [ngClass]="formFieldCss" class="pr-3" [class.full-width]="fullWidth" [class.select-disabled]="isDisabled" appearance="fill">
			<mat-label *ngIf="label && !italicPlaceholder">{{ label }}</mat-label>
			<mat-label *ngIf="!!italicPlaceholder"
				><i [ellipsisTooltip]="true">{{ italicPlaceholder }}</i></mat-label
			>
			<mat-icon class="mat-prefix" *ngIf="prefix" matPrefix>{{ prefix }}</mat-icon>

			<mat-select
				[disabled]="isDisabled"
				[formControlName]="controlName"
				[placeholder]="placeholder"
				[compareWith]="compareWithSomething"
				[panelClass]="showSearch ? 'search-panel' : ''"
				(openedChange)="onOpenChange($event)"
				[multiple]="multiple"
			>
				<mat-select-trigger>
					<!-- Only show the main label for the selected value, not the subline -->
				<ng-container *ngIf="optionValueKey">
					{{ getSelectedDisplayText() }}
				</ng-container>
				<!-- No optionValueKey - use currentValue directly -->
				<ng-container *ngIf="!optionValueKey && form.get(controlName)?.value as currentValue">
						{{ getLocale(
							currentValue?.[optionLabelKey] || currentValue?.label || currentValue?.name || currentValue?.id || currentValue,
							currentValue?.locale?.[optionLabelKey] || currentValue?.locales?.[optionLabelKey] || currentValue?.locale?.label || currentValue?.locales?.label
						 ) }}
					</ng-container>
				</mat-select-trigger>
				<mat-form-field *ngIf="showSearch" class="full-width no-hint" appearance="fill">
					<mat-label i18n="Search Label@@adminExternalDataSourcesDataRecordSearchLabel">Search</mat-label>
					<input
						matInput
						#searchInput
						(keydown)="$event.stopPropagation()"
						(keyup)="$event.stopPropagation(); onKey($event.target.value)"
					/>
					<mat-icon matPrefix>search</mat-icon>
				</mat-form-field>
				<!-- Key -->
				<ng-container *ngIf="optionValueKey">
					<mat-option
						*ngFor="let option of options | filterArray: searchFn : showSearch : searchString : optionLabelKey : searchKeys"
						[value]="option[optionValueKey]"
						[matTooltip]="option.tooltip ? option.tooltip : null"
						[matTooltipPosition]="'left'"
						[class.multiline]="sublineKey"
					>
						<div>
							{{
								getLocale(
									getOptionLabel(option),
									option.locale?.label || option.locales?.label
								)
							}}
						</div>
						<div *ngIf="sublineKey && option[sublineKey]" class="subline">
							{{ getLocale(option[sublineKey], option.locale?.label || option.locales?.label) }}
						</div>
					</mat-option>
				</ng-container>

				<!-- No Key -->
				<ng-container *ngIf="!optionValueKey">
					<mat-option
						*ngFor="let option of options | filterArray: searchFn : showSearch : searchString : optionLabelKey : searchKeys"
						[value]="option"
						[matTooltip]="option.tooltip ? option.tooltip : null"
						[class.multiline]="sublineKey"
					>
						<div>
							{{
								getLocale(
									getOptionLabel(option),
									option.locale?.label || option.locales?.label
								)
							}}
						</div>
						<div *ngIf="sublineKey && option[sublineKey]" class="subline">
							{{ getLocale(option[sublineKey], option.locale?.label || option.locales?.label) }}
						</div>
					</mat-option>
				</ng-container>
			</mat-select>
		</mat-form-field>

		<app-set-locale-edit-button
			*ngIf="showLocale"
			[localeData]="localeData"
			[selection]="options"
			(localeChange)="localeChange.emit($event)"
		></app-set-locale-edit-button>
	</div>

	<div *ngIf="hint" class="input-hint text-pretty">{{ hint }}</div>
</ng-container>
